<template>
  <section class="section-hero">
    <div class="container">
      <div class="row align-items-center">
        <!-- 左側: ロゴ + テキスト -->
        <div class="col-md-6 hero-text fade-in-up">
          <img src="/img/logo.png" alt="Guuu Eats" class="hero-logo">
          <h1 class="hero-title">
            学食DX：キャンパスランチを<br>もっと楽しく、便利に。
          </h1>
          <p class="hero-subtitle">Guuu Eats &times; 群馬大学</p>
          <p class="hero-tagline">Your New Campus Standard.</p>
        </div>
        <!-- 右側: 弁当画像 -->
        <div class="col-md-6 hero-image fade-in-up delay-2">
          <img src="/img/top/obento.jpg" alt="お弁当" class="hero-img">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionHero',
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables';
@import '@/assets/scss/mixins';

.section-hero {
  padding: $section-padding-y 0;
  background-color: $color-bg;
  overflow: hidden;

  @include media-down(768px) {
    padding: $section-padding-y-sm 0;
    text-align: center;
  }
}

.hero-logo {
  width: 200px;
  margin-bottom: 1.5rem;

  @include media-down(768px) {
    width: 160px;
  }
}

.hero-title {
  font-size: $font-size-hero-title;
  font-weight: 700;
  color: $color-text;
  line-height: 1.4;
  margin-bottom: 1rem;

  @include media-down(768px) {
    font-size: 1.75rem;
  }
}

.hero-subtitle {
  font-size: $font-size-section-subtitle;
  color: $color-primary;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.hero-tagline {
  font-size: $font-size-body;
  color: $color-text-light;
  font-style: italic;
  letter-spacing: 0.05em;
}

.hero-image {
  @include media-down(768px) {
    margin-top: 2rem;
  }
}

.hero-img {
  width: 100%;
  height: auto;
  border-radius: $border-radius-lg;
  object-fit: cover;
}
</style>
